import React from 'react';
import {FaPhotoVideo} from "react-icons/fa";
import {BlackListUser} from "services/blackListService";

interface AddPhotosBlackListUserButtonProps {
    user: BlackListUser;
    onAddPhotos: (user: BlackListUser) => void;
}

export const AddPhotosBlackListUserButton: React.FC<AddPhotosBlackListUserButtonProps> =
    ({
         user,
         onAddPhotos
     }) => {
        return (
            <button
                className="btn btn-outline-secondary btn-sm d-flex flex-row align-items-center"
                onClick={(e) => {
                    e.stopPropagation();
                    onAddPhotos(user);
                }}
                title="Добавить фото"
            >
                <FaPhotoVideo size={14} style={{marginRight: 4}}/>
                Добавить фото
            </button>
        );
    };
